import React from "react";
import { Container, Typography, Grid } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ChartCard from "./ChartCard";
import SummaryCard from "./SummaryCard";
import MetricCard from "./MetricCard";
import WideCard from "./WideCard";
import ElectricMeterIcon from "@mui/icons-material/ElectricMeter";

const EasyDashboard = ({
  hourlyProduction,
  avgDailyProduction,
  maxDailyProduction,
  minDailyProduction,
  chosenSetupDetail,
}) => {
  console.log("EZT KAPOM CHARTBA,    ", hourlyProduction);

  const chartOptions = {
    chart: { type: "line", height: 350 },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        formatter: (value) => value.toFixed(2), // Round to two decimal places
      },
    },
    stroke: { curve: "smooth" },
    title: { text: "Monthly Production Average", align: "left" },
  };

  const chartSeries = [
    { name: "Solar Production", data: hourlyProduction }, // Placeholder for monthly averages
  ];

  const summaryData = [
    {
      label: "Yearly Power",
      value: `${chosenSetupDetail.power.toFixed(0)} kWh`,
      color: "primary",
    },
    {
      label: "Total Expenses",
      value: `${chosenSetupDetail.upFrontCost.toFixed(0)}$ (USD)`,
      color: "error",
    },
    {
      label: "Break Even Time",
      value: `${(
        chosenSetupDetail.upFrontCost / chosenSetupDetail.savings
      ).toFixed(1)} years`,
      color: "success.main",
    },
  ];

  const metrics = [
    {
      icon: ElectricMeterIcon,
      title: "Consumption Coverage",
      value: `${(chosenSetupDetail.progress * 100).toFixed(0)}%`,
      subtitle: "Avg. yearly",
      color: "primary",
    },

    {
      icon: AttachMoneyIcon,
      title: "Savings",
      value: `${chosenSetupDetail.savings.toFixed(0)}$`,
      subtitle: "early savings",
      color: "success",
    },
  ];

  const wideCardMetrics = [
    {
      label: "Average",
      value: `${avgDailyProduction.toFixed(0)} kWh`,
      color: "secondary",
    },
    {
      label: "Max",
      value: `${maxDailyProduction.toFixed(0)} kWh`,
      color: "secondary",
    },
    {
      label: "Minimum",
      value: `${minDailyProduction.toFixed(0)} kWh`,
      color: "secondary",
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, pb: 4, px: 2 }}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <ChartCard options={chartOptions} series={chartSeries} />
        </Grid>
        <Grid item xs={12} md={4}>
          <SummaryCard title="Summary" data={summaryData} />
        </Grid>
      </Grid>
      <Grid container spacing={3} sx={{ mt: 3 }}>
        {metrics.map((metric, index) => (
          <Grid item xs={12} md={4} key={index}>
            <MetricCard {...metric} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <WideCard
            title="Daily production statistics"
            metrics={wideCardMetrics}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default EasyDashboard;
